import { Controller } from "@hotwired/stimulus";

// Downloads a file via fetch instead of a native form submit, so the surrounding
// modal can be closed once the file has actually been delivered.
// Native file downloads (Content-Disposition: attachment) don't navigate the
// page and don't fire turbo:submit-end, so a modal would otherwise stay open.
export default class extends Controller {
  static targets = ["submit", "label", "loader"]

  async download(event) {
    event.preventDefault();

    const form = this.element;
    const params = new URLSearchParams(new FormData(form)).toString();
    const url = `${form.action}${form.action.includes("?") ? "&" : "?"}${params}`;

    this.setLoading();

    try {
      const response = await fetch(url, { headers: { Accept: "application/xlsx" } });
      if (!response.ok) throw new Error(`Download failed: ${response.status}`);

      const blob = await response.blob();
      this.triggerDownload(blob, this.filenameFrom(response));
      this.closeModal();
    } catch (error) {
      console.error(error);
      this.setIdle();
    }
  }

  triggerDownload(blob, filename) {
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = objectUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);
  }

  filenameFrom(response) {
    const disposition = response.headers.get("Content-Disposition") || "";
    const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
    return match ? decodeURIComponent(match[1]) : "export.xlsx";
  }

  closeModal() {
    const modalElement = this.element.closest('[data-controller~="modal"]');
    if (!modalElement) return;

    const modal = this.application.getControllerForElementAndIdentifier(modalElement, "modal");
    if (modal) modal.close();
  }

  setLoading() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = true;
    if (this.hasLoaderTarget) this.loaderTarget.classList.remove("hidden");
    if (this.hasLabelTarget) this.labelTarget.classList.add("hidden");
  }

  setIdle() {
    if (this.hasSubmitTarget) this.submitTarget.disabled = false;
    if (this.hasLoaderTarget) this.loaderTarget.classList.add("hidden");
    if (this.hasLabelTarget) this.labelTarget.classList.remove("hidden");
  }
}
